import { useEffect, useState } from 'react'
import { copyText } from '../utils/clipboard'
import { Icon } from './Icon'

/** The one icon that copies a piece of generated text. It shows a check for a moment once the text is on the clipboard. */
export function CopyIconButton({ text, label = 'Copy text', className = 'btn btn-ghost btn-square' }: { text: string; label?: string; className?: string }) {
  const [copied, setCopied] = useState(false)
  useEffect(() => {
    if (!copied) return
    const timer = window.setTimeout(() => setCopied(false), 1_500)
    return () => window.clearTimeout(timer)
  }, [copied])
  return <button type="button" className={className} aria-label={copied ? 'Copied' : label} title={copied ? 'Copied' : label}
    onClick={() => { void copyText(text).then(() => setCopied(true), () => setCopied(false)) }}>
    <Icon name={copied ? 'check' : 'copy'} />
  </button>
}
